export { default as CreateIB } from './page'


// WEBPACK FOOTER //
// ./src/pages/createIB/index.js